module.exports = __webpack_public_path__ + "images/twitter@2x.png?35583212";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter@2x.png
// module id = 711
// module chunks = 7